<div *ngIf="items;else loadingBlock" class="list-container" style="margin-top: 25px;">
  <mat-list-item *ngFor="let item of items;" (click)="loadContent(item)" [ngClass]="{active: isActive(item)}">
    <div matListItemTitle>{{item?.descrizione}}</div>
  </mat-list-item>

</div>
<ng-template #loadingBlock>
  <div class="mt-25">
    <mat-spinner diameter="50"></mat-spinner>
    <span class="text-primary">Caricamento in corso...</span>
  </div>
</ng-template>
